import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Badge, Row, Col } from 'react-bootstrap';
import InfiniteScroll from "react-infinite-scroll-component";

const VacationSummary = ({ calculoVacaciones, perfil }) => {
    // Estado para controlar cuántos períodos mostrar
    const allPeriodos = calculoVacaciones.desglosePorAnio ? [...calculoVacaciones.desglosePorAnio].reverse() : [];
    const [displayCount, setDisplayCount] = useState(5);

    // Períodos actualmente visibles
    const periodosVisibles = allPeriodos.slice(0, displayCount);
    const hasMore = displayCount < allPeriodos.length;

    const loadMore = () => {
        setDisplayCount(prev => Math.min(prev + displayCount, allPeriodos.length));
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';

        try {
            let date;

            // 1. Si la fecha ya viene como "DD/MM/AAAA" (con diagonales)
            if (typeof dateString === 'string' && dateString.includes('/')) {
                const partes = dateString.split('/');
                if (partes.length === 3) {
                    const dia = parseInt(partes[0], 10);
                    const mes = parseInt(partes[1], 10) - 1; // En JS los meses van de 0 a 11
                    const anio = parseInt(partes[2], 10);

                    date = new Date(anio, mes, dia);
                }
            }
            // 2. Si viene como formato ISO largo o similar
            else {
                date = new Date(dateString);
            }

            // Validar si logramos construir una fecha real y sana
            if (date && !isNaN(date.getTime())) {
                return date.toLocaleDateString('es-ES', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                });
            }

            return dateString;
        } catch (error) {
            console.error("Error en formatDate:", error);
            return dateString || '-';
        }
    };

    console.log("allPeriodos", allPeriodos)

    return (
        <div className="border rounded-3 p-4 bg-white shadow-sm">
            <Row>
                <Col className="d-flex align-items-center mb-3">
                    <h5 className="mb-0 text-primary fw-bold d-flex align-items-center">
                        <FontAwesomeIcon icon="calendar-alt" className="me-2" />
                        Días de Vacaciones
                    </h5>
                </Col>
                {/*<Col xs={12} md={3} className="d-flex flex-wrap gap-4 gap-xl-5 text-muted small">

                    <Button>
                        Historial de vacacaiones
                    </Button>

                </Col>*/}
            </Row> 
            <Row className="align-items-center g-3 mb-4">
                <Col xs={12} md={9} className="d-flex flex-wrap gap-4 gap-xl-5 text-muted small">
                    <span className="d-flex align-items-center">
                        <FontAwesomeIcon icon="calendar-alt" className="me-2 text-muted opacity-75" />
                        <span className="me-1">Fecha de ingreso:</span>
                        <strong className="text-dark fw-bold">
                            {perfil.dFechaIngreso ? formatDate(perfil.dFechaIngreso) : '-'}
                        </strong>
                    </span>

                    <span className="d-flex align-items-center">
                        <FontAwesomeIcon icon="clock" className="me-2 text-muted opacity-75" />
                        <span className="me-1">Años de servicio:</span>
                        <strong className="text-dark fw-bold">
                            {calculoVacaciones.aniosServicio || '-'}
                        </strong>
                    </span>

                    <span className="d-flex align-items-center">
                        <FontAwesomeIcon icon="tag" className="me-2 text-muted opacity-75" />
                        <span className="me-1">Categoría:</span>
                        <strong className="text-dark fw-bold">
                            {perfil.vCategoria || '-'}
                        </strong>
                    </span>
                </Col>
            </Row>

            {/* SECCIÓN DE CONTADORES NUMÉRICOS GENERALES */}
            <div className="mb-4">
                <Row className="g-3">
                    <Col xs={4}>
                        <div
                            className="p-3 bg-success bg-opacity-10 rounded-3 border border-success border-opacity-25 text-center h-100 d-flex flex-column justify-content-center"
                            style={{ backgroundColor: 'rgba(25, 135, 84, 0.03)' }}
                        >
                            <small className="text-muted fw-medium d-block mb-1" style={{ fontSize: '0.78rem' }}>
                                Disponibles
                            </small>
                            <h2 className="mb-0 text-success fw-bold display-6 lh-1">
                                {calculoVacaciones.diasDisponibles || '-'}
                            </h2>
                        </div>
                    </Col>

                    <Col xs={4}>
                        <div
                            className="p-3 bg-danger bg-opacity-10 rounded-3 border border-danger border-opacity-25 text-center h-100 d-flex flex-column justify-content-center"
                            style={{ backgroundColor: 'rgba(220, 53, 69, 0.03)' }}
                        >
                            <small className="text-muted fw-medium d-block mb-1" style={{ fontSize: '0.78rem' }}>
                                Utilizados
                            </small>
                            <h2 className="mb-0 text-danger fw-bold display-6 lh-1">
                                {calculoVacaciones.diasUtilizados || '-'}
                            </h2>
                        </div>
                    </Col>

                    <Col xs={4}>
                        <div
                            className="p-3 bg-primary bg-opacity-10 rounded-3 border border-primary border-opacity-25"
                            style={{ backgroundColor: 'rgba(13, 110, 253, 0.04)' }}
                        >
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <small className="text-muted text-uppercase fw-bold d-block mb-1" style={{ fontSize: '0.68rem', letterSpacing: '0.5px' }}>
                                        Total acumulado
                                    </small>
                                    <h2 className="mb-0 text-primary fw-bold display-6 lh-1">
                                        {calculoVacaciones.diasTotales || '-'}
                                    </h2>
                                </div>
                                <Badge bg="primary" className="px-2 py-1 text-uppercase fw-bold shadow-sm" style={{ fontSize: '0.62rem', letterSpacing: '0.5px' }}>
                                    días generados
                                </Badge>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            {/* SECCIÓN DE PERÍODOS DE SERVICIO (TIMELINE VERTICAL) */}
            {allPeriodos.length > 0 && (
                <div className="mt-4 border-top pt-3">
                    <h5 className="mb-3 text-primary fw-bold d-flex align-items-center">
                        <FontAwesomeIcon icon="clock" className="me-2" />
                        Periodos de Servicio
                    </h5>

                    {/* El contenedor objetivo que maneja el Scrollbar idéntico a Historial de Movimientos */}
                    <div
                        id="scrollableTimelineContainer"
                        style={{
                            maxHeight: '350px', // Altura exacta a la de tu historial de movimientos
                            overflowY: 'auto',
                            paddingLeft: '40px', // Padding correcto para que la línea y avatares respiren
                            paddingRight: '10px'
                        }}
                    >
                        <InfiniteScroll
                            dataLength={periodosVisibles.length}
                            next={loadMore}
                            hasMore={hasMore}
                            scrollableTarget="scrollableTimelineContainer"
                            style={{ overflow: 'visible' }} // Permite que los círculos sobresalgan a la izquierda
                            loader={
                                <div className="text-center py-3">
                                    <FontAwesomeIcon icon="spinner" spin className="text-primary me-2" />
                                    <span className="text-muted small">Cargando más periodos...</span>
                                </div>
                            }
                            endMessage={
                                !hasMore && periodosVisibles.length > 0 && (
                                    <div className="text-center py-3 border-top-0">
                                        <small className="text-muted fw-medium" style={{ fontSize: '0.8rem' }}>
                                            <FontAwesomeIcon icon="check-circle" className="text-success me-1" />
                                            Todos los períodos mostrados
                                        </small>
                                    </div>
                                )
                            }
                        >
                            <div className="position-relative">
                                <div
                                    className="position-absolute bg-primary"
                                    style={{
                                        left: '22px', // Centrado exacto alineado con los círculos
                                        top: '15px',
                                        bottom: '15px',
                                        width: '2px', // Mismo grosor que el del historial de movimientos
                                        opacity: '0.2',
                                        zIndex: 1
                                    }}
                                />

                                {periodosVisibles.map((periodo, index) => {
                                    const esProporcional = periodo.iAnio === 0 || (periodo.bPeriodoActivo && !periodo.bPeriodoCompletado);
                                    const esActivo = periodo.bPeriodoActivo;
                                    const esCompletado = periodo.bPeriodoCompletado;
                                    const tieneDiasDisponibles = periodo.iDiasDisponibles > 0;

                                    return (
                                        <div
                                            key={index}
                                            className="position-relative mb-3 d-flex align-items-start"
                                        >
                                            <div
                                                className="position-absolute d-flex flex-column align-items-center"
                                                style={{
                                                    left: '11px',  // Mantiene el centrado horizontal respecto a la línea
                                                    top: '12px',   // Altura de inicio
                                                    zIndex: 2,
                                                    transform: 'translateX(-25%)'
                                                }}
                                            >
                                                <div
                                                    className={`rounded-circle bg-white d-flex align-items-center justify-content-center shadow-sm ${esActivo ? 'text-success' : tieneDiasDisponibles ? 'text-info' : 'text-info'}`}
                                                    style={{
                                                        width: '24px', // Tamaño original
                                                        height: '24px',
                                                        border: '3px solid currentColor',
                                                    }}
                                                >
                                                </div>

                                                {periodo.dFechaInicio && (() => {
                                                    let añoInico = '';

                                                    if (typeof periodo.dFechaInicio === 'string') {
                                                        if (periodo.dFechaInicio.includes('/')) {
                                                            const partes = periodo.dFechaInicio.split('/');
                                                            añoInico = partes[partes.length - 1];
                                                        } else if (periodo.dFechaInicio.includes('-')) {
                                                            añoInico = periodo.dFechaInicio.split('-')[0];
                                                        }
                                                    }

                                                    if (!añoInico || isNaN(añoInico)) {
                                                        const dateObj = new Date(periodo.dFechaInicio);
                                                        if (!isNaN(dateObj.getTime())) {
                                                            añoInico = dateObj.getFullYear();
                                                        }
                                                    }

                                                    return añoInico ? (
                                                        <small
                                                            className="fw-bold text-dark mt-1"
                                                            style={{
                                                                fontSize: '1.05rem',
                                                                letterSpacing: '0.2px',
                                                                lineHeight: '1.2'
                                                            }}
                                                        >
                                                            {añoInico}
                                                        </small>
                                                    ) : null;
                                                })()}
                                            </div>

                                            <div
                                                className={`rounded-3 p-3 border w-100 ms-5 ${esActivo ? 'bg-success bg-opacity-10 border-success shadow-sm' :
                                                        tieneDiasDisponibles ? 'bg-info bg-opacity-10 border-info' :
                                                        'bg-info bg-opacity-10 border-info'}`}
                                                style={{
                                                    transition: 'all 0.2s ease',
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = 'translateX(2px)';
                                                    e.currentTarget.style.boxShadow = '0 4px rgba(0,0,0,0.1)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = 'translateX(0)';
                                                    e.currentTarget.style.boxShadow = '';
                                                }}
                                            >
                                                <Row className="align-items-center g-1">
                                                    <Col xs={12} md={5} lg={4}>
                                                        <div>
                                                            <h1 className="mb-1 fw-bold text-dark" style={{ fontSize: '0.95rem' }}>
                                                                {periodo.vDescripcionAnio || `Año ${periodo.iAnio} de Servicio`}
                                                            </h1>

                                                            <div className="mb-2">
                                                                {esActivo && (
                                                                    <Badge bg="success" className="pulse-badge me-1" style={{ fontSize: '0.62rem', padding: '0.25rem 0.45rem' }}>
                                                                        <FontAwesomeIcon icon="circle" className="me-1" style={{ fontSize: '0.38rem' }} />
                                                                        EN CURSO
                                                                    </Badge>
                                                                )}
                                                                {!esActivo && esCompletado && (
                                                                    <Badge bg="secondary" className="bg-opacity-70" style={{ fontSize: '0.62rem', padding: '0.25rem 0.45rem' }}>
                                                                        <FontAwesomeIcon icon="check" className="me-1" />
                                                                        COMPLETADO
                                                                    </Badge>
                                                                )}
                                                            </div>

                                                            <div className="mb-2">
                                                                <small className="text-muted d-block" style={{ fontSize: '0.72rem' }}>
                                                                    <FontAwesomeIcon icon="calendar-alt" className="me-1 opacity-50" />
                                                                    {periodo.dFechaInicio ? formatDate(periodo.dFechaInicio) : ''} → {periodo.dFechaFin ? formatDate(periodo.dFechaFin) : ''}
                                                                </small>
                                                            </div>

                                                            {((esProporcional && esActivo) || (tieneDiasDisponibles && esCompletado)) && (
                                                                <div className="mt-2">
                                                                    {esProporcional && esActivo && (
                                                                        <div className="p-1 d-inline-block w-100">
                                                                            <small className="text-info d-block fw-medium" style={{ fontSize: '0.68rem' }}>
                                                                                <FontAwesomeIcon icon="info-circle" className="me-1" />
                                                                                Días En acumulación
                                                                            </small>
                                                                        </div>
                                                                    )}
                                                                    {tieneDiasDisponibles && esCompletado && (
                                                                        <div className="p-1 d-inline-block w-100">
                                                                            <small className="text-success d-block fw-medium" style={{ fontSize: '0.68rem' }}>
                                                                                <FontAwesomeIcon icon="star" className="me-1" />
                                                                                Días para usar
                                                                            </small>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </Col>

                                                    {/* Columna Derecha: Estadísticas en paralelo */}
                                                    <Col xs={12} md={7} lg={8}>
                                                        <Row className="g-2 text-center">
                                                            <Col xs={4}>
                                                                <div className="p-2 bg-white rounded shadow-sm border border-light">
                                                                    <span className="d-block fw-bold text-dark" style={{ fontSize: '1.25rem' }}>
                                                                        {periodo.iDiasGenerados}
                                                                    </span>
                                                                    <small className="text-muted text-uppercase d-block fw-medium" style={{ fontSize: '0.65rem', letterSpacing: '0.3px' }}>
                                                                        Generados
                                                                    </small>
                                                                </div>
                                                            </Col>

                                                            <Col xs={4}>
                                                                <div className="p-2 bg-white rounded shadow-sm border border-light">
                                                                    <span className="d-block fw-bold text-danger" style={{ fontSize: '1.25rem' }}>
                                                                        {periodo.iDiasUtilizados}
                                                                    </span>
                                                                    <small className="text-muted text-uppercase d-block fw-medium" style={{ fontSize: '0.65rem', letterSpacing: '0.3px' }}>
                                                                        Utilizados
                                                                    </small>
                                                                </div>
                                                            </Col>

                                                            <Col xs={4}>
                                                                <div className="p-2 bg-white rounded shadow-sm border border-light">
                                                                    {periodo.iDiasDisponibles === 0 ? (
                                                                        <FontAwesomeIcon icon="check-circle" className="text-success d-block my-1 mx-auto" style={{ fontSize: '1.25rem' }} />
                                                                    ) : (
                                                                        <span className="d-block fw-bold text-success" style={{ fontSize: '1.25rem' }}>
                                                                            {periodo.iDiasDisponibles}
                                                                        </span>
                                                                    )}
                                                                    <small className="text-muted text-uppercase d-block fw-medium" style={{ fontSize: '0.65rem', letterSpacing: '0.3px' }}>
                                                                        Disponibles
                                                                    </small>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </InfiniteScroll>
                    </div>
                </div>
            )}            
        </div>
    );
};

VacationSummary.propTypes = {
    calculoVacaciones: PropTypes.shape({
        diasTotales: PropTypes.number.isRequired,
        diasUtilizados: PropTypes.number.isRequired,
        diasDisponibles: PropTypes.number.isRequired,
        aniosServicio: PropTypes.number.isRequired,
        desglosePorAnio: PropTypes.arrayOf(PropTypes.shape({
            iAnio: PropTypes.number,
            vDescripcionAnio: PropTypes.string,
            dFechaInicio: PropTypes.string,
            dFechaFin: PropTypes.string,
            iDiasGenerados: PropTypes.number,
            iDiasUtilizados: PropTypes.number,
            iDiasDisponibles: PropTypes.number,
            bPeriodoActivo: PropTypes.bool,
            bPeriodoCompletado: PropTypes.bool,
            decPorcentajeAvance: PropTypes.number,
            vEstadoPeriodo: PropTypes.string
        })).isRequired
    }).isRequired,
    perfil: PropTypes.shape({
        dFechaIngreso: PropTypes.string,
        vCategoria: PropTypes.string
    }).isRequired
};

export default VacationSummary;